const qualitySliderSections = document.querySelectorAll( "#quality" );
qualitySliderSections.forEach( ( section, i ) => {
  const ind = section.querySelector( ".slider-indicator" );
  const slider = tns( {
    container: section.querySelector( ".slider" ),
    items: 1,
    // center: true,
    autoplay: false,
    controls: true,
    nav: false,
    //navContainer: section.querySelector('.team-slider-nav'),
    loop: false,
    autoplayButtonOutput: false,
    controlsContainer: section.querySelector( ".slider-controls" ),
    speed: 500,
    gutter: 12,
    // fixedHeight: true,
    responsive: {
      768: {
        items: 1,
        gutter: 24,
      },
      1024: {
        gutter: 24,
      },
      1200: {
        fixedWidth: 1035,
        gutter: 24,
      },
    },
  } );

  slider.events.on( "transitionStart", function ( info ) {
    console.log( info.index );
    ind.style.transform = `translateX(${ info.index * 100 }%)`;
  } );
} );
